var _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.962 10.481",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "canadaFlagTitle"
  }, "Flag of Canada") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "canadaFlagTitle"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagBlue",
    y: -0.02,
    width: 8.227,
    height: 5.648
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: ".798 4.848 .626 4.952 .672 4.757 .52 4.626 .72 4.609 .798 4.424 .876 4.609 1.076 4.626 .924 4.757 .97 4.952 .798 4.848"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.124 4.848 1.952 4.952 1.998 4.757 1.846 4.626 2.046 4.609 2.124 4.424 2.202 4.609 2.402 4.626 2.25 4.757 2.296 4.952 2.124 4.848"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.777 4.848 4.605 4.952 4.651 4.757 4.499 4.626 4.699 4.609 4.777 4.424 4.854 4.609 5.054 4.626 4.902 4.757 4.948 4.952 4.777 4.848"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "3.45 4.848 3.279 4.952 3.325 4.757 3.173 4.626 3.373 4.609 3.45 4.424 3.528 4.609 3.728 4.626 3.576 4.757 3.622 4.952 3.45 4.848"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "7.429 4.848 7.257 4.952 7.303 4.757 7.151 4.626 7.351 4.609 7.429 4.424 7.507 4.609 7.707 4.626 7.555 4.757 7.601 4.952 7.429 4.848"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.103 4.848 5.931 4.952 5.977 4.757 5.825 4.626 6.025 4.609 6.103 4.424 6.18 4.609 6.381 4.626 6.228 4.757 6.274 4.952 6.103 4.848"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "1.461 4.377 1.289 4.481 1.335 4.286 1.183 4.155 1.383 4.138 1.461 3.953 1.539 4.138 1.739 4.155 1.587 4.286 1.633 4.481 1.461 4.377"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.787 4.377 2.616 4.481 2.662 4.286 2.509 4.155 2.71 4.138 2.787 3.953 2.865 4.138 3.065 4.155 2.913 4.286 2.959 4.481 2.787 4.377"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "5.44 4.377 5.268 4.481 5.314 4.286 5.162 4.155 5.362 4.138 5.44 3.953 5.517 4.138 5.717 4.155 5.565 4.286 5.611 4.481 5.44 4.377"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.113 4.377 3.942 4.481 3.988 4.286 3.836 4.155 4.036 4.138 4.113 3.953 4.191 4.138 4.391 4.155 4.239 4.286 4.285 4.481 4.113 4.377"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.766 4.377 6.594 4.481 6.64 4.286 6.488 4.155 6.688 4.138 6.766 3.953 6.844 4.138 7.044 4.155 6.892 4.286 6.938 4.481 6.766 4.377"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: ".798 3.906 .626 4.01 .672 3.815 .52 3.684 .72 3.667 .798 3.482 .876 3.667 1.076 3.684 .924 3.815 .97 4.01 .798 3.906"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.124 3.906 1.952 4.01 1.998 3.815 1.846 3.684 2.046 3.667 2.124 3.482 2.202 3.667 2.402 3.684 2.25 3.815 2.296 4.01 2.124 3.906"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.777 3.906 4.605 4.01 4.651 3.815 4.499 3.684 4.699 3.667 4.777 3.482 4.854 3.667 5.054 3.684 4.902 3.815 4.948 4.01 4.777 3.906"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "3.45 3.906 3.279 4.01 3.325 3.815 3.173 3.684 3.373 3.667 3.45 3.482 3.528 3.667 3.728 3.684 3.576 3.815 3.622 4.01 3.45 3.906"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "7.429 3.906 7.257 4.01 7.303 3.815 7.151 3.684 7.351 3.667 7.429 3.482 7.507 3.667 7.707 3.684 7.555 3.815 7.601 4.01 7.429 3.906"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.103 3.906 5.931 4.01 5.977 3.815 5.825 3.684 6.025 3.667 6.103 3.482 6.18 3.667 6.381 3.684 6.228 3.815 6.274 4.01 6.103 3.906"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "1.461 3.435 1.289 3.539 1.335 3.344 1.183 3.213 1.383 3.196 1.461 3.011 1.539 3.196 1.739 3.213 1.587 3.344 1.633 3.539 1.461 3.435"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.787 3.435 2.616 3.539 2.662 3.344 2.509 3.213 2.71 3.196 2.787 3.011 2.865 3.196 3.065 3.213 2.913 3.344 2.959 3.539 2.787 3.435"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "5.44 3.435 5.268 3.539 5.314 3.344 5.162 3.213 5.362 3.196 5.44 3.011 5.517 3.196 5.717 3.213 5.565 3.344 5.611 3.539 5.44 3.435"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.113 3.435 3.942 3.539 3.988 3.344 3.836 3.213 4.036 3.196 4.113 3.011 4.191 3.196 4.391 3.213 4.239 3.344 4.285 3.539 4.113 3.435"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.766 3.435 6.594 3.539 6.64 3.344 6.488 3.213 6.688 3.196 6.766 3.011 6.844 3.196 7.044 3.213 6.892 3.344 6.938 3.539 6.766 3.435"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: ".798 2.964 .626 3.068 .672 2.873 .52 2.742 .72 2.725 .798 2.54 .876 2.725 1.076 2.742 .924 2.873 .97 3.068 .798 2.964"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.124 2.964 1.952 3.068 1.998 2.873 1.846 2.742 2.046 2.725 2.124 2.54 2.202 2.725 2.402 2.742 2.25 2.873 2.296 3.068 2.124 2.964"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.777 2.964 4.605 3.068 4.651 2.873 4.499 2.742 4.699 2.725 4.777 2.54 4.854 2.725 5.054 2.742 4.902 2.873 4.948 3.068 4.777 2.964"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "3.45 2.964 3.279 3.068 3.325 2.873 3.173 2.742 3.373 2.725 3.45 2.54 3.528 2.725 3.728 2.742 3.576 2.873 3.622 3.068 3.45 2.964"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "7.429 2.964 7.257 3.068 7.303 2.873 7.151 2.742 7.351 2.725 7.429 2.54 7.507 2.725 7.707 2.742 7.555 2.873 7.601 3.068 7.429 2.964"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.103 2.964 5.931 3.068 5.977 2.873 5.825 2.742 6.025 2.725 6.103 2.54 6.18 2.725 6.381 2.742 6.228 2.873 6.274 3.068 6.103 2.964"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "1.461 2.493 1.289 2.598 1.335 2.402 1.183 2.271 1.383 2.254 1.461 2.069 1.539 2.254 1.739 2.271 1.587 2.402 1.633 2.598 1.461 2.493"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.787 2.493 2.616 2.598 2.662 2.402 2.509 2.271 2.71 2.254 2.787 2.069 2.865 2.254 3.065 2.271 2.913 2.402 2.959 2.598 2.787 2.493"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "5.44 2.493 5.268 2.598 5.314 2.402 5.162 2.271 5.362 2.254 5.44 2.069 5.517 2.254 5.717 2.271 5.565 2.402 5.611 2.598 5.44 2.493"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.113 2.493 3.942 2.598 3.988 2.402 3.836 2.271 4.036 2.254 4.113 2.069 4.191 2.254 4.391 2.271 4.239 2.402 4.285 2.598 4.113 2.493"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.766 2.493 6.594 2.598 6.64 2.402 6.488 2.271 6.688 2.254 6.766 2.069 6.844 2.254 7.044 2.271 6.892 2.402 6.938 2.598 6.766 2.493"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: ".798 2.022 .626 2.127 .672 1.931 .52 1.8 .72 1.783 .798 1.598 .876 1.783 1.076 1.8 .924 1.931 .97 2.127 .798 2.022"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.124 2.022 1.952 2.127 1.998 1.931 1.846 1.8 2.046 1.783 2.124 1.598 2.202 1.783 2.402 1.8 2.25 1.931 2.296 2.127 2.124 2.022"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.777 2.022 4.605 2.127 4.651 1.931 4.499 1.8 4.699 1.783 4.777 1.598 4.854 1.783 5.054 1.8 4.902 1.931 4.948 2.127 4.777 2.022"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "3.45 2.022 3.279 2.127 3.325 1.931 3.173 1.8 3.373 1.783 3.45 1.598 3.528 1.783 3.728 1.8 3.576 1.931 3.622 2.127 3.45 2.022"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "7.429 2.022 7.257 2.127 7.303 1.931 7.151 1.8 7.351 1.783 7.429 1.598 7.507 1.783 7.707 1.8 7.555 1.931 7.601 2.127 7.429 2.022"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.103 2.022 5.931 2.127 5.977 1.931 5.825 1.8 6.025 1.783 6.103 1.598 6.18 1.783 6.381 1.8 6.228 1.931 6.274 2.127 6.103 2.022"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: ".798 1.081 .626 1.185 .672 .989 .52 .858 .72 .842 .798 .656 .876 .842 1.076 .858 .924 .989 .97 1.185 .798 1.081"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.124 1.081 1.952 1.185 1.998 .989 1.846 .858 2.046 .842 2.124 .656 2.202 .842 2.402 .858 2.25 .989 2.296 1.185 2.124 1.081"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.777 1.081 4.605 1.185 4.651 .989 4.499 .858 4.699 .842 4.777 .656 4.854 .842 5.054 .858 4.902 .989 4.948 1.185 4.777 1.081"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "3.45 1.081 3.279 1.185 3.325 .989 3.173 .858 3.373 .842 3.45 .656 3.528 .842 3.728 .858 3.576 .989 3.622 1.185 3.45 1.081"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "7.429 1.081 7.257 1.185 7.303 .989 7.151 .858 7.351 .842 7.429 .656 7.507 .842 7.707 .858 7.555 .989 7.601 1.185 7.429 1.081"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.103 1.081 5.931 1.185 5.977 .989 5.825 .858 6.025 .842 6.103 .656 6.18 .842 6.381 .858 6.228 .989 6.274 1.185 6.103 1.081"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "1.461 1.552 1.289 1.656 1.335 1.46 1.183 1.329 1.383 1.312 1.461 1.127 1.539 1.312 1.739 1.329 1.587 1.46 1.633 1.656 1.461 1.552"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "2.787 1.552 2.616 1.656 2.662 1.46 2.509 1.329 2.71 1.312 2.787 1.127 2.865 1.312 3.065 1.329 2.913 1.46 2.959 1.656 2.787 1.552"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "5.44 1.552 5.268 1.656 5.314 1.46 5.162 1.329 5.362 1.312 5.44 1.127 5.517 1.312 5.717 1.329 5.565 1.46 5.611 1.656 5.44 1.552"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "4.113 1.552 3.942 1.656 3.988 1.46 3.836 1.329 4.036 1.312 4.113 1.127 4.191 1.312 4.391 1.329 4.239 1.46 4.285 1.656 4.113 1.552"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "usFlagWhite",
    points: "6.766 1.552 6.594 1.656 6.64 1.46 6.488 1.329 6.688 1.312 6.766 1.127 6.844 1.312 7.044 1.329 6.892 1.46 6.938 1.656 6.766 1.552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    y: 9.683,
    width: 17.962,
    height: 0.798
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    y: 8.069,
    width: 17.962,
    height: 0.798
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    y: 6.455,
    width: 17.962,
    height: 0.798
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagWhite",
    y: 5.648,
    width: 17.962,
    height: 0.798
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagWhite",
    y: 7.262,
    width: 17.962,
    height: 0.798
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagWhite",
    y: 8.876,
    width: 17.962,
    height: 0.798
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    x: 8.227,
    y: 4.841,
    width: 9.735,
    height: 0.798
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    x: 8.227,
    y: 3.228,
    width: 9.735,
    height: 0.798
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    x: 8.227,
    y: 1.614,
    width: 9.735,
    height: 0.798
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagRed",
    x: 8.227,
    width: 9.735,
    height: 0.798
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagWhite",
    x: 8.227,
    y: 0.807,
    width: 9.735,
    height: 0.798
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagWhite",
    x: 8.227,
    y: 2.421,
    width: 9.735,
    height: 0.798
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "usFlagWhite",
    x: 8.227,
    y: 4.035,
    width: 9.735,
    height: 0.798
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaIcon);
export default __webpack_public_path__ + "static/media/USA_Icon.439d4ab3352112e43ce0795409396200.svg";
export { ForwardRef as ReactComponent };